import { styled } from "@mui/material";

import CheckSvg from "./check.svg";

const RADIO_SIZE = 16;
const HIT_PADDING = 4;
const HIT_SIZE = RADIO_SIZE + HIT_PADDING * 2;

// The input is the hit target, so it has to be the bigger box — a pseudo
// element can't take a click. The negative margin gives back the extra space
// so surrounding layout still sees a 16px control, and ::before paints the
// visible one.
const Radio = styled("input")(({ theme }) => ({
  boxSizing: "border-box",
  appearance: "none",
  background: "none",
  border: "none",
  padding: 0,
  cursor: "pointer",
  margin: -HIT_PADDING,
  font: "inherit",
  width: HIT_SIZE,
  height: HIT_SIZE,
  display: "grid",
  flexShrink: 0,
  placeContent: "center",

  "&::before": {
    content: '""',
    gridArea: "1 / 1",
    boxSizing: "border-box",
    width: RADIO_SIZE,
    height: RADIO_SIZE,
    borderRadius: "50%",
    backgroundColor: theme.palette.cf.cfGrey,
    border: `0.15em solid ${theme.palette.cf.cfGrey}`,
  },

  "&::after": {
    content: '""',
    gridArea: "1 / 1",
    width: RADIO_SIZE,
    height: RADIO_SIZE,
    borderRadius: "50%",
    transform: "scale(0)",
    transition: "120ms transform ease-in-out",
    background: `${theme.palette.cf.cfLightGreen} url("${CheckSvg}") center center no-repeat`,
  },

  // Hover previews the checked state so the click has no surprise in it.
  "&:checked::after, &:hover:not(:disabled)::after": {
    transform: "scale(1)",
  },

  "&:disabled": {
    cursor: "not-allowed",
  },

  "&:disabled::before": {
    backgroundColor: theme.palette.cf.cfLightGrey,
    borderColor: theme.palette.cf.cfLightGrey,
  },

  "&:disabled:checked::after": {
    // check.svg bakes cf.cfPrimary green into the icon itself, so a
    // background-color swap behind it has no visible effect — desaturate
    // the rendered pixels instead.
    filter: "grayscale(1)",
  },
}));

Radio.defaultProps = {
  type: "radio",
};

export { Radio };
